import { AppConstants } from '@/helpers/app.constants';
import { TrackingHelper } from '@/helpers/tracking.helper';
import { AlertService } from '@/services/alert.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { ConsumptionRecords, ConsumptionType, NextTimeStep, RealProperty, TrackingService } from '@eemo/api-client';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { InputDecimalValueDirective } from '../../extensions/inputDecimalValueDirective';
import { InputTrimDirective } from '../../extensions/inputTrimDirective';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatOptionModule } from '@angular/material/core';
import { NgFor, NgIf } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

export class PropertyConsumptionAddDialogData {
  prop: RealProperty;
}

@Component({
    selector: 'app-property-consumption-add-dialog',
    templateUrl: './property-consumption-add-dialog.component.html',
    styleUrls: ['./property-consumption-add-dialog.component.scss'],
    standalone: true,
    imports: [MatDialogModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, NgFor, MatOptionModule, MatRadioModule, NgIf, MatInputModule, InputTrimDirective, InputDecimalValueDirective, MatIconModule, MatButtonModule]
})
export class PropertyConsumptionAddDialogComponent implements OnInit {
  consumptionForm: UntypedFormGroup;
  dialogTitle: string;
  formSubmitting = false;
  currentMeasureType: string;
  dataAdded = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PropertyConsumptionAddDialogData,
    private fb: UntypedFormBuilder,
    private trackingService: TrackingService,
    private alertService: AlertService,
    public dialogRef: MatDialogRef<PropertyConsumptionAddDialogComponent>,
    public trackingHelper: TrackingHelper
  ) {
    this.dialogTitle = 'Ajouter une consommation';
  }

  // convenience getter for easy access to form fields
  f(field: string): AbstractControl {
    return this.consumptionForm.get(field);
  }

  ngOnInit() {
    this.consumptionForm = this.fb.group({
      type: [ConsumptionType.ELECTRICITY, Validators.required],
      measureType: ['MONTH', Validators.required],
      monthStart: ['01', Validators.required],
      yearStart: [this.trackingHelper.getCurrentYear(), [Validators.required, Validators.pattern('[0-9]{4}')]],
      monthEnd: ['01', Validators.required],
      yearEnd: [this.trackingHelper.getCurrentYear(), [Validators.required, Validators.pattern('[0-9]{4}')]],
      value: [null, [Validators.required, Validators.pattern(AppConstants.FORM_PATTERN_POSITIVE_DECIMAL)]],
      price: [null, Validators.pattern(AppConstants.FORM_PATTERN_POSITIVE_DECIMAL)]
    });
    this.currentMeasureType = 'MONTH';
  }

  onSubmit() {
    if (this.consumptionForm.valid) {
      this.formSubmitting = true;
      const consumptionRecords: ConsumptionRecords = { type: this.f('type').value, records: [] };
      consumptionRecords.records.push({
        monthStart: this.f('monthStart').value + '-' + this.f('yearStart').value,
        monthEnd:
          this.f('measureType').value === 'PERIOD'
            ? this.f('monthEnd').value + '-' + this.f('yearEnd').value
            : this.f('monthStart').value + '-' + this.f('yearStart').value,
        value: this.f('value').value,
        price: this.f('price').value
      });
      this.trackingService.addPropertyConsumptionRecords(this.data.prop.uid, consumptionRecords).subscribe(
        (result: NextTimeStep) => {
          this.formSubmitting = false;
          const nextStart = result.nextMonthStart.split('-');
          const nextEnd = result.nextMonthEnd.split('-');
          this.alertService.success('Consommation enregistrée avec succès');
          this.dataAdded = true;
          const currrentType = this.f('type').value;
          const currentMeasureType = this.f('measureType').value;
          const currentValue = this.f('value').value;
          const currentPrice = this.f('price').value;
          this.consumptionForm.reset();
          this.f('type').setValue(currrentType);
          this.f('measureType').setValue(currentMeasureType);
          this.f('monthStart').setValue(nextStart[0]);
          this.f('yearStart').setValue(nextStart[1]);
          this.f('monthEnd').setValue(nextEnd[0]);
          this.f('yearEnd').setValue(nextEnd[1]);
          this.f('value').reset('0');
          this.f('price').setValue(currentPrice);
        },
        (err: HttpErrorResponse) => {
          this.dialogRef.close(false);
        }
      );
    }
  }
  onNoClick(): void {
    this.dialogRef.close(this.dataAdded);
  }

  measureTypeChanged(event: any) {
    this.currentMeasureType = this.f('measureType').value;
  }
}
